import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { LIVE_POLL, livePollInterval } from '../config/liveSync';
import { adminKeys } from '../lib/queryKeys';

/** Safety-net refresh while the admin app is visible. */
export function useAdminLiveSync(enabled: boolean) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enabled) return undefined;

    const refresh = () => {
      if (document.hidden) return;
      void queryClient.invalidateQueries({ queryKey: adminKeys.all });
    };

    const onVisibility = () => {
      if (!document.hidden) {
        refresh();
      }
    };

    document.addEventListener('visibilitychange', onVisibility);
    const interval = setInterval(refresh, livePollInterval(LIVE_POLL.LIST) || LIVE_POLL.LIST);

    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      clearInterval(interval);
    };
  }, [enabled, queryClient]);
}
